import React from 'react'
import { Link } from "react-router-dom";

const EVChargingSolution = () => {
  return (
    <>

      <div className="page-header dark-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="A Complete Guide to Solar Energy ..." style={{ perspective: 400 }}>
                  <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                    <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                      EV Charging Solution
                    </div>
                  </div>
                </h1>
                <div className="post-single-meta wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <ol className="breadcrumb">
                    <a to='/'> <li><i className="fa-regular fa-user" /> Home</li></a>
                    <li><i className="fa-regular fa-clock" /> EV Charging Solution</li>
                  </ol>
                </div>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>

      <div className="page-service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              {/* Page Single Sidebar Start */}
              <div className="page-single-sidebar">
                {/* Page Category List Start */}
                <div className="page-category-list wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <h2 className="page-category-list-title">Explore Our Services</h2>
                  <ul>
                    <li><Link to="/EV-charging-solution">EV Charging Solution</Link></li>
                    <li><Link to="/solar-electrical-installation">Solar & Electrical Installation</Link></li>
                    <li><Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></li>
                    <li><Link to="/solar-water-heater-solution">Solar Water Heater Solution</Link></li>
                    <li><Link to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></li>
                    <li><Link to="/solar-water-pump-solution">Solar Water Pump Solution</Link></li>
                  </ul>
                </div>
                {/* Page Category List End */}
                {/* Sidebar CTA Box Start */}
                <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                  <div className="sidebar-cta-header">
                    <div className="icon-box">
                      <img src="./assets/images/icon-headphone-white.svg" alt />
                    </div>
                    <div className="sidebar-cta-image">
                      <figure>
                        <img src="./assets/images/sidebar-cta-image.png" alt />
                      </figure>
                    </div>
                  </div>
                  <div className="sidebar-cta-body">
                    <h2>Contact Us For a Quote</h2>
                    <ul>
                      <li>Call Us: <a href="tel:+91 9516839231">+91 9516839231</a></li>
                    </ul>
                  </div>
                </div>
                {/* Sidebar CTA Box End */}
              </div>
              {/* Page Single Sidebar End */}
            </div>
            <div className="col-lg-8">
              {/* Service Single Content Start */}
              <div className="service-single-content">
                {/* Page Single Image Start */}
                <div className="page-single-image">
                  <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                    <img src="./assets/solar/EV Charging Solution.webp" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                  </figure>
                </div>
                {/* Page Single Image End */}
                {/* Service Entry Start */}
                <div className="service-entry">
                  <div className="service-offer-box">
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Smart & Reliable Electric Vehicle Charging Solutions
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>At Solar World Enterprises, we provide modern EV Charging Solutions designed to support the growing demand for electric mobility. Our solutions are suitable for homes, offices, commercial properties, residential societies, hotels, parking facilities, institutions, and other locations looking to establish reliable electric vehicle charging infrastructure.</p>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>We help customers plan and install EV charging systems according to their vehicle requirements, available electrical capacity, parking layout, and future charging needs.</p>

                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          EV Charger Installation
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>  We provide professional installation of EV charging equipment with suitable electrical connections, protection systems, cabling, and mounting arrangements.</p>
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Residential EV Charging
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}> We provide convenient charging solutions for homeowners who want to charge their electric cars, scooters, or other compatible vehicles at home. </p>
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Commercial EV Charging
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}> Our commercial charging solutions are suitable for offices, hotels, shopping areas, parking facilities, residential complexes, and other properties that want to provide EV charging facilities to customers, employees, or residents. </p>
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Solar-Powered EV Charging
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}> We can integrate EV charging with solar energy systems, allowing electric vehicles to be charged using renewable solar power where the site and system configuration are suitable. </p>
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          EV Charging Infrastructure
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}> We assist with planning the required charging infrastructure, including charger placement, electrical capacity assessment, cabling, protection equipment, and installation requirements. </p>
                  </div>
                  {/* Service Offer Box End */}
                  {/* Service Key Benefits Start */}
                  <div className="service-key-benefits">
                    {/* Service Key Benefits Body Start */}
                    <div className="service-key-benefits-body">
                      {/* Service Benefits Image Start */}
                      <div className="service-benefit-image">
                        <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                          <img src="./assets/images/service-benefit-image.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                        </figure>
                      </div>
                      {/* Service Benefits Image End */}
                      {/* Service Benefits Item List Start */}
                      <div className="service-benefit-item-list">
                        {/* Service Benefits Item Start */}
                        <div className="service-benefit-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                          <div className="icon-box">
                            <img src="./assets/images/icon-service-benefit-1.svg" alt />
                          </div>
                          <div className="service-benefit-item-content">
                            <h3>Our EV Charging Process</h3>
                            <p><b>Requirement Assessment → Site Survey → Electrical Load Assessment → Charger Selection → Installation Planning → Charger Installation → Testing & Commissioning → Customer Support</b></p>
                            <h3>Why Choose Solar World Enterprises?</h3>
                            <p>At Solar World Enterprises, we combine our solar and electrical expertise to provide practical EV charging solutions tailored to individual site requirements. We focus on professional installation, safety, reliable operation, and ongoing customer support.</p>
                          </div>

                        </div>
                      </div>
                      {/* Service Benefits Item List End */}
                    </div>

                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', marginTop: "20px" }}>
                          Key Benefits
                        </div>
                      </div>
                    </h2>
                    <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li><b> ⚡ Convenient Charging:</b>  Provides accessible charging where vehicles are parked.</li>
                        <li><b> 🌱 Supports Clean Mobility:</b>  Helps support the transition toward electric transportation.</li>
                        <li><b> ☀️ Solar Integration:</b>  Can be combined with solar power for renewable-energy-based charging.</li>
                        <li><b> 🏢 Flexible Applications:</b>  Suitable for residential, commercial, institutional, and public-facing locations.</li>
                        <li><b> 🔌 Professional Installation:</b> Proper electrical planning and installation for dependable operation. </li>
                        <li><b> 📈 Future-Ready Infrastructure:</b>  Charging infrastructure can be planned with future EV adoption in mind.</li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default EVChargingSolution